import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { SUPPORTED_PAGES } from '../../_builder-constants'

const MENU_ITEM_SCHEMA: FieldSchema[] = [
  { key: 'label', label: 'Label', type: 'string' },
  { key: 'href', label: 'Link URL', type: 'string' },
  {
    key: 'type',
    label: 'Type',
    type: 'select',
    options: [
      { label: 'Link', value: 'link' },
      { label: 'Store categories (each with a dropdown)', value: 'categories' },
    ],
    default: 'link',
  },
  { key: 'badge', label: 'Badge', type: 'string', placeholder: 'New', help: 'Small label next to the item.' },
]

/**
 * Khelaghor header: butter announcement strip, logo, wide search, Account / wishlist / Cart tiles, then the sticky
 * lilac category bar (menu items; a "categories" item expands to the store's top categories with dropdowns) ending in
 * the grape deals button.
 */
export const schema: ComponentSchema = {
  type: 'header',
  label: 'Header',
  description: 'Announcement strip, logo, search, account and cart tiles, and the category bar with its deals button.',
  supportedPages: [...SUPPORTED_PAGES],
  variants: [{ id: 'v1', label: 'Main row and category bar' }],
  commonFields: [
    { key: 'logo.src', label: 'Logo', type: 'image' },
    { key: 'logo.alt', label: 'Logo alt text', type: 'string' },
    {
      key: 'topbar',
      label: 'Announcement strip',
      type: 'object',
      fields: [
        { key: 'active', label: 'Show announcement bar', type: 'boolean', default: true },
        {
          key: 'messages',
          label: 'Messages',
          type: 'array',
          help: 'More than one message rotates every few seconds.',
          itemSchema: [
            { key: 'text', label: 'Text', type: 'localized-string' },
            { key: 'link', label: 'Link', type: 'string' },
          ],
        },
        { key: 'dismissible', label: 'Shoppers can close it', type: 'boolean', default: false },
      ],
    },
    { key: 'searchPlaceholder', label: 'Search placeholder', type: 'string', placeholder: 'Search toys, school bags, baby care…' },
    {
      key: 'dealsLabel',
      label: 'Deals button text',
      type: 'localized-string',
      default: 'Today’s deals',
      help: 'The grape button at the right end of the category bar. Empty = no button.',
    },
    { key: 'dealsLink', label: 'Deals button link', type: 'string', placeholder: '/offers', default: '/offers' },
    {
      key: 'actions',
      label: 'Icons',
      type: 'object',
      fields: [
        { key: 'showSearch', label: 'Search', type: 'boolean', default: true },
        { key: 'showAccount', label: 'Account', type: 'boolean', default: true },
        { key: 'showWishlist', label: 'Wishlist', type: 'boolean', default: true },
        { key: 'showCart', label: 'Cart', type: 'boolean', default: true },
        {
          key: 'cartAction',
          label: 'Cart opens',
          type: 'select',
          options: [
            { label: 'Cart drawer', value: 'sidebar' },
            { label: 'Cart page', value: 'page' },
          ],
          default: 'sidebar',
        },
      ],
    },
    { key: 'menu', label: 'Category bar', type: 'array', help: 'Add an item of type "Store categories" to show your top categories with their dropdowns.', itemSchema: MENU_ITEM_SCHEMA },
  ],
}
